import { cloneElement } from 'react';
import { InputProps, useInput } from 'react-admin';

interface BoundedInputProps extends InputProps {
    input: React.ReactElement
}
const BoundedInput = (props: BoundedInputProps) => {
    const { onChange, onBlur, source, ...rest } = props;
    const {
        field,
        fieldState: { isTouched, invalid, error },
        formState: { isSubmitted },
        isRequired
    } = useInput<any>({
        // Pass the event handlers to the hook but not the component as the field property already has them.
        // useInput will call the provided onChange and onBlur in addition to the default needed by react-hook-form.
        onChange,
        onBlur,
        ...props,
    });

    return cloneElement(props.input, {
        ...field,
        label: props.label,
        error: (isTouched || isSubmitted) && invalid,
        helperText: (isTouched || isSubmitted) && invalid ? error : false,
        required: isRequired,
        fullWidth: true,
        sx:{ gridArea: source.split('.').pop() },
        source,
        ...rest,
    })
}

export default BoundedInput;